import script from "./LootBoxApeInfoOdd.vue?vue&type=script&setup=true&lang=js"
export * from "./LootBoxApeInfoOdd.vue?vue&type=script&setup=true&lang=js"

import "./LootBoxApeInfoOdd.vue?vue&type=style&index=0&id=bcbb114a&lang=scss"

const __exports__ = script;

export default __exports__